export default __webpack_public_path__ + "static/media/plaine-commune.46c11858.mp4";